import { DatePicker, Textfield } from '@workboard/wobo-ui';
import React, { useMemo } from 'react';
import { unreachable } from '../utils/unreachable';

export type UniversalFieldType = 'number' | 'text' | 'date';

export type UniversalFieldDef<V, C = undefined> = {
  name: string;
  label: string;
  value: V;
  helperText?: string;
  isError?: boolean;
  isDisabled?: boolean;
  onChange(e: React.ChangeEvent<unknown>, val: V): void;
  getValue?: (val: any) => any;
  context: C;

  type?: UniversalFieldType;
  render?: (def: UniversalFieldDef<V, C>) => React.ReactElement;
};

type Props<V, C> = UniversalFieldDef<V, C>;

export const UniversalField = <V, C = undefined>({
  getValue,
  type,
  render,
  ...props
}: Props<V, C>): React.ReactElement => {
  const fieldProps = useMemo(
    () => ({
      ...props,
      onChange: (e, val) => {
        const value = getValue?.(val) ?? val;
        props.onChange(e, value);
      },
    }),
    [props, getValue]
  );
  if (render) {
    return render(fieldProps);
  }
  if (type) {
    switch (type) {
      case 'number':
        return <Textfield type="number" {...fieldProps} />;
      case 'text':
        return <Textfield {...fieldProps} />;
      case 'date':
        return <DatePicker {...fieldProps} />;
      default:
        unreachable(type);
    }
  }
  return <div />;
};
